window.dataLayer = window.dataLayer || [];

function pushViewItem() {
  if (Shopify && Shopify.designMode) return;

  if (meta && meta.product) {
    const variant = meta.product.variants[0];
    dataLayer.push({
      event: 'view_item',
      ecommerce: {
        items: [{
          item_name: meta.product.title,
          item_id: meta.product.id,
          price: variant.price / 100,
          item_brand: meta.product.vendor,
          item_category: meta.product.type
        }]
      }
    });
  }
}

function pushAddToCart(e) {
  if (!e.target.closest('form[action*="/cart/add"]')) return;

  const form = e.target.closest('form');
  const qty = form.querySelector('[name="quantity"]')?.value || 1;

  dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      value: qty,
      items: [{
        item_name: meta.product.title,
        item_id: meta.product.id,
        quantity: qty
      }]
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  pushViewItem();
  document.body.addEventListener('click', pushAddToCart);
});
